import React from "react";
import { PropTypes } from "prop-types";
import { DeleteForever as DeleteForeverIcon } from "@material-ui/icons";
import LoaderEditor from "./loaderEditor/LoaderEditor";

import "css/admin/utils/module-image-upload.scss";

function SimpleImageUpload({
  id,
  isDisabled,
  label,
  value,
  onImageChange,
  format,
  rounded,
  onFileLoad,
  onDelete,
  isLoading,
}) {
  const handleChange = (e) => {
    e.preventDefault();
    onImageChange(e); // legacy
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => onFileLoad(reader.result);
    reader.readAsDataURL(file);
  };

  const handleDelete = () => {
    onDelete();
  };
  const backgroundImageStyle = { backgroundImage: `url(${value})` };

  const isDeletable = value && !!onDelete;

  return (
    <div className="editor-form-pictures-container editor-form-pictures-inline">
      <div className="editor-form-pictures">
        {label && <label>{label}</label>}
        <div className="editor-form-pictures-row">
          <div
            className={`editor-form-picture-${format} ${
              rounded ? "editor-form-picture-rounded" : ""
            }`}
          >
            <div
              className={
                value && value.length > 0
                  ? "editor-form-picture editor-form-picture-exist"
                  : "editor-form-picture"
              }
              style={backgroundImageStyle}
            >
              {!isDisabled && (
                <label
                  className="editor-form-picture-label"
                  htmlFor={`${id}-picture-upload-${format}`}
                >
                  <LoaderEditor loading={isLoading}>
                    <i className="material-icons">file_upload</i>
                  </LoaderEditor>
                </label>
              )}
              {isDeletable && (
                <div
                  className="editor-form-picture-delete"
                  onClick={handleDelete}
                >
                  <DeleteForeverIcon />
                </div>
              )}
              <input
                id={`${id}-picture-upload-${format}`}
                className="editor-form-picture-input"
                disabled={isDisabled}
                type="file"
                accept=".gif,.jpg,.jpeg,.png,.ico"
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SimpleImageUpload.defaultProps = {
  onFileLoad: () => {},
  onImageChange: () => {},
};

SimpleImageUpload.propTypes = {
  id: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  value: PropTypes.string,
  onImageChange: PropTypes.func,
  onFileLoad: PropTypes.func,
  onDelete: PropTypes.func,
  format: PropTypes.oneOf(["16_6", "16_9", "3_4", "1_1"]),
  label: PropTypes.string,
  rounded: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default SimpleImageUpload;
